import { render } from "./HBEConfig.vue?vue&type=template&id=00353908&scoped=true"
import script from "./HBEConfig.vue?vue&type=script&lang=js"
export * from "./HBEConfig.vue?vue&type=script&lang=js"

import "./HBEConfig.vue?vue&type=style&index=0&id=00353908&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00353908"]])

export default __exports__